import { useCallback, useState } from 'react';

import PropTypes from 'prop-types';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useIntl } from '@zenbusiness/application-commons-intl';

import ConfirmationContent from './ConfirmationContent/ConfirmationContent';
import OptInContent from './OptInContent/OptInContent';
import * as Styled from './SMSOptInCard.style';

const PHONE_SMS_REMINDER_IMAGE_PATH = '/s2/raster/phone-sms-reminder.png';

export const LOCALIZED_TEXT = {
  close: 'dashboard.carousel.card.smsOptIn.button.close',
  imageAlt: 'dashboard.carousel.card.smsOptIn.imageAlt',
};

function SMSOptInCard({
  currentPhoneNumber = '',
  handleCardDismissed = () => {},
  handleSaveNotificationPreferences = () => {},
  isSavingPhoneNumber = false,
}) {
  const { formatMessage: fm } = useIntl();
  const [showConfirmationContent, setShowConfirmationContent] = useState(false);

  const handleOnOptIn = useCallback(
    (...params) => {
      handleSaveNotificationPreferences(...params);
      setShowConfirmationContent(true);
    },
    [handleSaveNotificationPreferences],
  );

  const handleCloseButtonOnClick = useCallback(() => {
    handleCardDismissed(true);
  }, [handleCardDismissed]);

  return (
    <Styled.Root>
      <Styled.IconButton
        clickstreamProps={{
          appSection: 'home',
          elementName: 'opt_in_card_close_button',
        }}
        label={fm({ id: LOCALIZED_TEXT.close })}
        onClick={handleCloseButtonOnClick}
      >
        <CloseRoundedIcon />
      </Styled.IconButton>
      <Styled.Image alt={fm({ id: LOCALIZED_TEXT.imageAlt })} src={PHONE_SMS_REMINDER_IMAGE_PATH} />
      {showConfirmationContent ? (
        <ConfirmationContent />
      ) : (
        <OptInContent currentPhoneNumber={currentPhoneNumber} onOptIn={handleOnOptIn} saving={isSavingPhoneNumber} />
      )}
    </Styled.Root>
  );
}

SMSOptInCard.propTypes = {
  currentPhoneNumber: PropTypes.string,
  handleCardDismissed: PropTypes.func,
  handleSaveNotificationPreferences: PropTypes.func,
  isSavingPhoneNumber: PropTypes.bool,
};

export default SMSOptInCard;
